module.exports = __webpack_public_path__ + "media/images/lig/uxu-gallery/gallery-item-3-2655d3c0ee78c61733e921673a19b58b.jpg";